class PaperlessbillinglandingController {
  constructor($state,$window,storage,billingService) {
    this.name = 'Paperless Billing';
    this.state = $state;

    //variables
    this.landingPagePaperlessLoader = true;
    this.email = null;
    this.emailButNotEnrolled  = false;
    this.emailAndEnrolled  = false;
    this.noEmail= false;
    this.hasOptimumId=true;
    this.errorFetchingInfo = false;


    billingService.getCurrectAcc().then((res)=>{

      if(!storage.getItem('session','hasOptimumId')){
        this.hasOptimumId=false;
        this.landingPagePaperlessLoader = false;
      }
      else if(res && !res.email){
        this.noEmail = true;
        this.landingPagePaperlessLoader = false;
      }
      else if(res && res.email && res.isPaperBill === "true"){
        this.emailButNotEnrolled  = true;
        storage.setItem('session','userEmail',res.email);
        this.landingPagePaperlessLoader = false;
      }
      else if(res && res.email && res.isPaperBill === "false"){
        this.emailAndEnrolled = true;
        storage.setItem('session','userEmail',res.email);
        var preEmail = res.email;
        var index = preEmail.indexOf("@");  
        var name = preEmail.substr(0, index); // Gets the first part
        var nameLength = name.length;
        console.log("name is " + name);
        var domain = preEmail.substr(index + 1);  // Gets the second part
        var domainLength = domain.length;
        var totalchar = domainLength + nameLength;
        console.log("domain is " + domain);

        if (totalchar <= 36) {
          this.email = res.email;
          console.log ("totalchar <= 36 and email is " + this.email);
        } else if (nameLength > 18 && domainLength > 18) {
          this.email = name.substring(0,16) + "...@" + domain.substring(0,16) + "...";
          console.log ("both large and email is " + this.email);
        } else if (nameLength > 18 && domainLength <= 18) {
          var newnameLength = 34 - domainLength;
          this.email = name.substring(0,newnameLength) + "...@" + domain;
          console.log ("name large and email is " + this.email);
        } else if (nameLength <= 18 && domainLength > 18) {
          var newdomainLength = 34 - nameLength;
          this.email = name.substring(0,nameLength) + "@" + domain.substring(0,newdomainLength) + "...";
          console.log ("domain large and email is " + this.email);
        } else {
          this.email = res.email;
          console.log ("no large and email is " + this.email);
        }
        this.landingPagePaperlessLoader = false;
      }
      else{
        this.errorFetchingInfo = true;
        this.landingPagePaperlessLoader = false;
      }
    });
  }

}

PaperlessbillinglandingController.$inject = ['$state','$window','storage','billingService'];

export default PaperlessbillinglandingController;



// WEBPACK FOOTER //
// ./client/app/components/landingpage/paperlessbillinglanding/paperlessbillinglanding.controller.js